import React from "react";
import {Brands} from "@core-ui/utility";
import {Icon} from "../components/Icon";
import {IconContainerProps} from "../types";

const CrossBrandSVG = (
  <svg fill="none" viewBox="0 0 46 46" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M46 23C46 35.7025 35.7025 46 23 46C10.2975 46 0 35.7025 0 23C0 10.2975 10.2975 0 23 0C35.7025 0 46 10.2975 46 23Z"
      fill="black"
    />
    <path
      clipRule="evenodd"
      d="M35.0002 13.9454C35.0002 12.871 34.1048 12 33.0002 12L13.0002 12C11.8956 12 11.0002 12.871 11.0002 13.9454V28.5357C11.0002 29.6101 11.8956 30.4811 13.0002 30.4811H16.0002L16.6879 35.1638C16.8095 35.9918 17.8776 36.2943 18.4371 35.6593L23.0002 30.4811H33.0002C34.1048 30.4811 35.0002 29.6101 35.0002 28.5357L35.0002 13.9454Z"
      fill="white"
      fillRule="evenodd"
    />
    <path
      clipRule="evenodd"
      d="M16.8673 30H13C12.4477 30 12 29.5523 12 29V14C12 13.4477 12.4477 13 13 13H33C33.5523 13 34 13.4477 34 14V29C34 29.5523 33.5523 30 33 30H22.5401L17.6777 35.6728L16.8673 30ZM16 31H13C11.8954 31 11 30.1046 11 29V14C11 12.8954 11.8954 12 13 12H33C34.1046 12 35 12.8954 35 14V29C35 30.1046 34.1046 31 33 31H23L18.4369 36.3236C17.8774 36.9764 16.8093 36.6654 16.6877 35.8142L16 31Z"
      fill="black"
      fillRule="evenodd"
    />
    <path
      d="M19.5 21.8701C19.5 22.6985 18.8284 23.3701 18 23.3701C17.1716 23.3701 16.5 22.6985 16.5 21.8701C16.5 21.0417 17.1716 20.3701 18 20.3701C18.8284 20.3701 19.5 21.0417 19.5 21.8701Z"
      fill="black"
    />
    <path
      d="M29.5 21.8701C29.5 22.6985 28.8284 23.3701 28 23.3701C27.1716 23.3701 26.5 22.6985 26.5 21.8701C26.5 21.0417 27.1716 20.3701 28 20.3701C28.8284 20.3701 29.5 21.0417 29.5 21.8701Z"
      fill="black"
    />
    <path
      d="M24.5 21.8701C24.5 22.6985 23.8284 23.3701 23 23.3701C22.1716 23.3701 21.5 22.6985 21.5 21.8701C21.5 21.0417 22.1716 20.3701 23 20.3701C23.8284 20.3701 24.5 21.0417 24.5 21.8701Z"
      fill="black"
    />
  </svg>
);

const brandIconSVGs = {
  [Brands.Athleta]: CrossBrandSVG,
  [Brands.BananaRepublic]: CrossBrandSVG,
  [Brands.BananaRepublicFactoryStore]: CrossBrandSVG,
  [Brands.Gap]: CrossBrandSVG,
  [Brands.GapFactoryStore]: CrossBrandSVG,
  [Brands.OldNavy]: CrossBrandSVG,
  crossBrand: CrossBrandSVG,
};

export const ChatIcon = (props: IconContainerProps): JSX.Element => (
  <Icon {...props} brandIconSVGs={brandIconSVGs} />
);
